import styled from 'styled-components';

import {
  Button as ButtonLayoutComponent,
  Text as TextLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  margin-top: 5px;
  padding: 0px 10px;
  width: 100%;
`;

export const ReleaseButton = styled(ButtonLayoutComponent)`
  width: max-content;
  &.ui.button {
    margin-bottom: 10px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const SegmentName = styled.p`
  font-weight: bold;
  display: block;
  margin-top: 16px;
`;

export const SegmentContainer = styled.div`
  margin-bottom: 2em;
`;

export const Text = styled(TextLayoutComponent)``;
